import { useGetPlans } from 'common/queries-and-mutations/payment';
import IWillPlan from 'components/IWillPlan';
import React, { useState } from 'react';
import { selectPlan } from 'utils';

export default function PlanDesktop() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedPlan, setSelectedPlan] = useState<number | null>(null);

  const { data: plans } = useGetPlans();

  return (
    <div className="mt-10 hidden w-full flex-col items-center justify-center bg-white px-20 md:mt-10 md:flex">
      <div className="text-center">
        <p className="font-circular text-[3rem] font-normal leading-tight text-[#1E063E]">
          Plans Prepared For
        </p>
        <p className="font-circular text-[3rem] font-normal leading-tight text-[#1E063E]">
          You By Us
        </p>
      </div>

      <div className="mt-4 grid grid-cols-12 gap-4 py-5 sm:mt-5 sm:gap-5 lg:mt-6 lg:gap-6">
        <div className="col-span-12 flex space-x-4 overflow-x-auto px-[var(--margin-x)] transition-all duration-[.25s] scrollbar-hide lg:pl-0">
          <div className="shrink-0 space-y-9 rounded-xl p-4 sm:px-5">
            <div className="flex flex-row items-center gap-5">
              {(plans ?? []).map(plan => (
                <IWillPlan
                  key={plan.planId}
                  iWillLogo={plan.image}
                  iWillPrice={plan.price}
                  iWillPackages={plan.packages}
                  iWillPlanId={plan.planId}
                  isRecommended={!!plan.isRecommended}
                  onPlanSelect={() => {
                    setSelectedPlan(plan.planId);
                    selectPlan(plan.planId, plans ?? []);
                  }}
                  isSelectedPlan={!!plan.isSelectedPlan}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
